export const DOCUMENT_SIZE_SCORE_UNIT_BYTES = 1000;

export const DOC_HEALTH_LIMITS = {
  healthyTargetBytes: 2_500 * DOCUMENT_SIZE_SCORE_UNIT_BYTES,
  warningBytes: 5_000 * DOCUMENT_SIZE_SCORE_UNIT_BYTES,
  criticalBytes: 7_500 * DOCUMENT_SIZE_SCORE_UNIT_BYTES,
  productHardBytes: 10_000 * DOCUMENT_SIZE_SCORE_UNIT_BYTES,
  emergencyBytes: 20_000 * DOCUMENT_SIZE_SCORE_UNIT_BYTES,
} as const;

export const DOC_SIZE_WARN_BYTES = DOC_HEALTH_LIMITS.warningBytes;
export const DOC_SIZE_LIMIT_BYTES = DOC_HEALTH_LIMITS.productHardBytes;

export function getDocumentSizeScore(sizeBytes: number): number {
  if (sizeBytes <= 0) return 0;
  return Math.ceil(sizeBytes / DOCUMENT_SIZE_SCORE_UNIT_BYTES);
}

export function formatDocumentSizeScore(sizeBytes: number): string {
  return String(getDocumentSizeScore(sizeBytes));
}
